import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import Instruction from '../../../modules/withdrawal/components/coordinator/Instruction';

const InstructionPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('withdrawal->>Coordinator.Header.TitleHeader')} />
      <Instruction />
    </>
  );
};

export default InstructionPage;
